var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 71,
    viewBox: "0 0 50 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_697_22920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 33C23 32.4477 23.4477 32 24 32H26C26.5523 32 27 32.4477 27 33V60C27 60.5523 26.5523 61 26 61H24C23.4477 61 23 60.5523 23 60V33Z",
    fill: "#3063E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9231,
    cy: 22.9231,
    r: 16.9231,
    fill: "#3063E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9231 17.8491C26.866 17.8491 28.4413 19.4331 28.4413 21.3877C28.4413 22.9065 27.4897 24.2018 26.1537 24.7038C26.0637 24.7376 26.0766 24.9264 26.1712 24.9427C27.7428 25.2133 29.1442 25.986 30.2064 27.0908C30.4739 27.3689 30.9192 27.4063 31.1783 27.1202C32.5488 25.6074 33.3845 23.5959 33.3845 21.3877C33.3845 16.6864 29.596 12.875 24.923 12.875C20.2499 12.875 16.4614 16.6864 16.4614 21.3877C16.4614 23.5959 17.2971 25.6073 18.6676 27.1202C18.9267 27.4062 19.3721 27.3689 19.6395 27.0907C20.7015 25.986 22.1028 25.2133 23.6745 24.9427C23.7691 24.9264 23.782 24.7376 23.692 24.7038C22.3561 24.2018 21.405 22.9064 21.405 21.3877C21.4051 19.4331 22.9802 17.8491 24.9231 17.8491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0124 30.9312C28.0124 32.642 26.6101 34.0289 24.8802 34.0289C23.1504 34.0289 21.7481 32.642 21.7481 30.9312C21.7481 29.2204 23.1504 27.8335 24.8802 27.8335C26.6101 27.8335 28.0124 29.2204 28.0124 30.9312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_697_22920",
    x: 0,
    y: 0,
    width: 49.8462,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_697_22920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_697_22920",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDrop);
export default __webpack_public_path__ + "static/media/pinDrop.17d04ad18c1525d5dc2feae81386a917.svg";
export { ForwardRef as ReactComponent };